if (!customElements.get('bargain-box-families')) {
  customElements.define(
    'bargain-box-families',
    class BargainBoxFamilies extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      async onClick(event) {
        const button = event.target.closest('[data-bbf-action]');
        if (!button || !this.contains(button) || button.disabled) return;

        const row = button.closest('[data-bbf-row]');
        if (!row || row.classList.contains('is-loading')) return;

        const action = button.dataset.bbfAction;
        const variantId = row.dataset.variantId;
        const lineKey = row.dataset.lineKey;
        const currentQuantity = Number(row.dataset.cartQuantity || 0);
        const inventoryQuantity = Number(row.dataset.inventoryQuantity || 0);
        let requestedQuantity = currentQuantity;

        if (action === 'add') requestedQuantity = 1;
        if (action === 'increase') requestedQuantity = currentQuantity + 1;
        if (action === 'decrease') requestedQuantity = Math.max(0, currentQuantity - 1);

        if (!variantId || requestedQuantity === currentQuantity) return;

        if (requestedQuantity > inventoryQuantity) {
          this.setRowMessage(row, `Only ${inventoryQuantity} available.`);
          return;
        }

        await this.updateVariant(row, variantId, lineKey, currentQuantity, requestedQuantity, action);
      }

      async updateVariant(row, variantId, lineKey, currentQuantity, requestedQuantity, action) {
        this.setLoading(row, true);
        this.setRowMessage(row, '');

        const sections = [this.sectionId, 'cart-icon-bubble'];
        const isAdding = currentQuantity === 0 && requestedQuantity > 0;
        const route = isAdding ? window.routes.cart_add_url : window.routes.cart_change_url;
        const body = isAdding
          ? {
              items: [{ id: Number(variantId), quantity: requestedQuantity }],
              sections,
              sections_url: window.location.pathname,
            }
          : {
              // Shopify's change endpoint expects a string line-item key or variant ID.
              // Passing it as a JavaScript number can trigger the "expected Integer" validation error.
              id: lineKey || variantId,
              quantity: requestedQuantity,
              sections,
              sections_url: window.location.pathname,
            };

        try {
          const response = await fetch(route, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify(body),
          });

          const state = await response.json();

          if (!response.ok || state.status || state.errors) {
            throw new Error(
              state.description ||
                state.message ||
                (typeof state.errors === 'string' ? state.errors : '') ||
                window.cartStrings?.error ||
                'The cart could not be updated.'
            );
          }

          this.renderSections(state.sections || {});

          const difference = requestedQuantity - currentQuantity;
          let message = 'Cart updated.';
          if (action === 'add') message = 'Added to cart.';
          if (difference > 0 && action === 'increase') message = 'Quantity increased.';
          if (difference < 0 && requestedQuantity > 0) message = 'Quantity decreased.';
          if (requestedQuantity === 0) message = 'Removed from cart.';
          this.announce(message);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'bargain-box-families',
              productVariantId: Number(variantId),
              cartData: state,
            });
          }
        } catch (error) {
          this.setRowMessage(row, error.message || window.cartStrings?.error || 'The cart could not be updated.');
        } finally {
          const currentRow = this.querySelector(`[data-bbf-row][data-variant-id="${variantId}"]`);
          if (currentRow) this.setLoading(currentRow, false);
        }
      }

      renderSections(sections) {
        const sectionHtml = sections[this.sectionId];
        if (sectionHtml) {
          const parsedSection = new DOMParser().parseFromString(sectionHtml, 'text/html');
          const newContent = parsedSection.querySelector('.bbf-section-content');
          const currentContent = this.querySelector('.bbf-section-content');
          if (newContent && currentContent) currentContent.innerHTML = newContent.innerHTML;
        }

        const cartIconHtml = sections['cart-icon-bubble'];
        const cartIcon = document.getElementById('cart-icon-bubble');
        if (cartIconHtml && cartIcon) {
          const parsedCartIcon = new DOMParser().parseFromString(cartIconHtml, 'text/html');
          const renderedSection = parsedCartIcon.querySelector('.shopify-section');
          cartIcon.innerHTML = renderedSection ? renderedSection.innerHTML : cartIconHtml;
        }
      }

      setLoading(row, loading) {
        row.classList.toggle('is-loading', loading);
        row.querySelectorAll('button').forEach((button) => {
          button.toggleAttribute('aria-disabled', loading);
        });
        row.querySelectorAll('.loading__spinner').forEach((spinner) => {
          spinner.classList.toggle('hidden', !loading);
        });
      }

      setRowMessage(row, message) {
        const messageElement = row.querySelector('[data-bbf-row-message]');
        if (messageElement) messageElement.textContent = message;
      }

      announce(message) {
        const liveRegion = this.querySelector('[data-bbf-live-region]');
        if (!liveRegion) return;
        liveRegion.textContent = '';
        window.setTimeout(() => {
          liveRegion.textContent = message;
        }, 50);
      }
    }
  );
}
